import type { Callback } from '../types'

export function nextTick<T = any>(callback: Callback<T>): Promise<T> {
  return Promise.resolve().then(callback)
}
